// extracted by mini-css-extract-plugin
export default {"leasing_driver":"use-main-tabs_leasing_driver__HpJc5","leasing":"use-main-tabs_leasing__QUNHU","history":"use-main-tabs_history__81Cs2"};